import styled from 'styled-components'

export const DropDownWrapper = styled.div`
  @media ${({ theme }) => theme.breakpoints.desktop} {
    position: absolute;
    display: flex;
    align-items: flex-end;
    padding-top: 85px;
    justify-content: space-between;
    top: 80px;
    left: 0;
    width: 100%;
    height: 219px;
    background-color: ${({ theme }) => theme.colors.light1};
    transition: all 500ms ease;
    z-index: 1000;
  }

  @media ${({ theme }) => theme.breakpoints.tablet} {
    max-width: 80%;
  }
  .DropDown-active {
    pointer-events: none;
    > svg {
      fill: ${({ theme }) => theme.colors.active1};
    }
  }
`

export const Text = styled.p`
  font-size: 19px;
  max-width: ${({ paragraphMax }) => (!!paragraphMax ? paragraphMax : '240px')};
  width: 100%;
  color: ${({ theme }) => theme.colors.grey1};
`
export const DropDownInner = styled.div`
  > a {
    &:hover {
      > svg {
        fill: ${({ theme }) => theme.colors.active1};
        transition: all 300ms ease;
        path {
          fill: ${({ theme }) => theme.colors.active1};
          stroke: ${({ theme }) => theme.colors.active1};
        }
      }
    }
    text-decoration: none;
    > h3 {
      font-size: 20px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.dark1};
      margin-bottom: 19px;
    }

    > p {
    }

    > svg {
      max-width: 80px;
      max-height: 80px;
      margin-bottom: 22px;
    }
  }

  @media ${({ theme }) => theme.breakpoints.desktop} {
    display: flex;
    padding: 0 0 56px 55px;

    > a {
      margin-right: 70px;
      width: 260px;
      &:last-child {
        margin-right: 40px;
      }
    }
  }

  @media ${({ theme }) => theme.breakpoints.tablet} {
    > a {
      &:active {
        fill: ${({ theme }) => theme.colors.active1};
        transition: all 300ms ease;
      }
      > p {
        padding-bottom: 35px;
      }
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 10px 86px 0 0;

  @media ${({ theme }) => theme.breakpoints.tablet} {
    display: none;
  }
`
